module.exports = __webpack_public_path__ + "static/media/spotify.df3c0ff2.svg";